import { CultivoRepository } from "../repository/cultivo_repository";

export class CultivoService {
	constructor() {
		this.cultivoRepository = new CultivoRepository();
	}

	async getAll(params) {
		const cultivoData = await this.cultivoRepository.getAll(params);
		return cultivoData;
	}
}
